
import React, { useEffect, useState } from "react";
import { Variables, variables } from '../../Variables.js';
import imageLogo from '../../img/logo.png';

function PointsReboundsAssists(props) {

    return (

        <div className="props">
            <ul>
                <li className="stat-list">
                    <div className="propOptions">
                        <h5>Points+Rebounds+Assists</h5>
                        <div className="work-request--options">
                            <span className="options-a">
                                <label htmlFor="ppg">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 150 111" xmlSpace="preserve">
                                        <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                            <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                        </g>
                                    </svg>
                                    {props.data.stats && props.data.stats.pts} PPG
                                </label>

                                <label htmlFor="rpg">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 150 111" xmlSpace="preserve">
                                        <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                            <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                        </g>
                                    </svg>
                                    {props.data.stats && props.data.stats.reb} RPG
                                </label>

                                <label htmlFor="apg">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 150 111" xmlSpace="preserve">
                                        <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                            <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                        </g>
                                    </svg>
                                    {props.data.stats && props.data.stats.ast} APG
                                </label>
                                <label htmlFor="ppgPrpgPapg">
                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 150 111" xmlSpace="preserve">
                                        <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                            <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                        </g>
                                    </svg>
                                    {props.data.stats && (parseFloat(props.data.stats.pts) + parseFloat(props.data.stats.reb) + parseFloat(props.data.stats.ast)).toFixed(2)} PPG+RPG+APG
                                </label>

                            </span>                            
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    )

};

export default PointsReboundsAssists;
